// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IvOl","toggleWrap":"styles_toggleWrap__3hLuE","content":"styles_content__1fJr9","selectAreaCode":"styles_selectAreaCode__2oTxx"};